import React from 'react';
import type { AccountContext } from './types';

function AccountStatusBadge({ status }: { status?: string | null }) {
  if (!status) {
    return <span className="text-gray-900 font-family-messina-sans">—</span>;
  }

  const statusClass =
    status === 'Open'
      ? 'bg-green-100 text-green-800'
      : status === 'Closed'
        ? 'bg-red-100 text-red-800'
        : 'bg-gray-100 text-gray-800';

  return (
    <span className={`inline-block px-2 py-1 rounded text-xs font-family-messina-sans ${statusClass}`}>
      {status}
    </span>
  );
}

export default function AccountContextPanel({ accountContext }: { accountContext?: AccountContext | null }) {
  const fullName = [accountContext?.firstname, accountContext?.lastname].filter(Boolean).join(' ') || '—';

  const fields = [
    { label: 'Artist name', value: accountContext?.artistName || '—' },
    { label: 'Full name', value: fullName },
    { label: 'Account number', value: accountContext?.accountNumber || '—' },
    {
      label: 'Account status',
      value: accountContext?.accountStatus ? (
        <AccountStatusBadge status={accountContext.accountStatus} />
      ) : (
        '—'
      ),
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-5">
      <h2 className="text-sm font-medium text-gray-900 font-family-messina-sans">Account details</h2>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {fields.map(({ label, value }) => (
          <div key={label}>
            <p className="text-[0.625rem] uppercase tracking-wide text-gray-500 sidebar-menu-item">{label}</p>
            <div className="text-sm text-gray-900 font-family-messina-sans mt-1 break-all">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
